export default {
	NEW_STORE: 1,
	OLD_STORE: 2,
}
